export enum API_VERSIONS {
  V2 = "2.0",
  V3 = "3.0",
}
